import script from "./PlayerTool.vue?vue&type=script&setup=true&lang=js"
export * from "./PlayerTool.vue?vue&type=script&setup=true&lang=js"

import "./PlayerTool.vue?vue&type=style&index=0&id=05d3d080&scoped=true&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05d3d080"]])

export default __exports__